module.exports = __webpack_public_path__ + "img/med.9930adce.svg";